import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { FeatureRow } from './components/FeatureRow';

// TODO(SP-669) https://mindfeed.atlassian.net/browse/SP-669 — learn links
// temporarily hidden for launch. To re-enable, restore the
// `LearnLink` import, uncomment this block, and pass `learnLinks={learnLinks}`
// to the <FeatureRow> below.
/*
const learnLinks: LearnLink[] = [
  {
    label: 'Learn about smart search',
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="11" cy="11" r="7" />
        <path d="M21 21l-4.3-4.3" />
      </svg>
    ),
  },
];
*/

const markClass = 'rounded-[3px] bg-[#FDF6BB] px-0.5 text-mf-off-black-600';

const results = [
  { color: '#2757BA', glyph: '"', key: 'r1' },
  { color: '#1f7a52', glyph: '▤', key: 'r2' },
  { color: '#c54b7d', glyph: '▶', key: 'r3' },
];

const Search = () => {
  const t = useTranslations();
  return (
    <div className={styles.search}>
      <div className={styles.bar.container}>
        <svg viewBox="0 0 24 24" className={styles.bar.icon}>
          <circle cx="11" cy="11" r="7" />
          <path d="M21 21l-4.3-4.3" />
        </svg>
        <span className={styles.bar.query}>churchill</span>
        <span className={styles.bar.cursor} />
      </div>
      <div className={styles.count}>{t('pages.home.section12.count')}</div>
      {results.map((result) => (
        <div key={result.key} className={styles.result.container}>
          <span
            className={styles.result.icon}
            style={{ backgroundColor: result.color }}
          >
            {result.glyph}
          </span>
          <div>
            <div className={styles.result.title}>
              {t(`pages.home.section12.${result.key}Title`)}
            </div>
            <div className={styles.result.subtitle}>
              {t.rich(`pages.home.section12.${result.key}Sub`, {
                mark: (chunks) => <mark className={markClass}>{chunks}</mark>,
              })}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const Section12 = () => {
  const t = useTranslations();
  return (
    <FeatureRow
      eyebrow={t('pages.home.section12.eyebrow')}
      title={t('pages.home.section12.title')}
      description={t('pages.home.section12.description')}
      visual={<Search />}
    />
  );
};

const styles = {
  search: classNames(
    'w-full max-w-[440px] overflow-hidden rounded-[18px] border bg-white p-5',
    'border-[#F0F0F0] shadow-[0_14px_36px_rgba(20,30,60,0.07)]',
    'marketing-dark:border-white/10 marketing-dark:shadow-[0_40px_90px_rgba(2,8,30,0.55)]',
  ),
  bar: {
    container: classNames(
      'flex items-center gap-[11px] rounded-full border px-[17px] py-[13px]',
      'border-[#DADADA] bg-white marketing-dark:border-[#e4e7ee] marketing-dark:bg-[#f4f5f7]',
    ),
    icon: 'h-[18px] w-[18px] flex-shrink-0 fill-none stroke-[#8a8f99] stroke-2',
    query: 'text-[15px] font-semibold text-mf-off-black-600',
    cursor: 'h-4 w-px animate-pulse bg-mf-blue',
  },
  count: 'mx-0.5 mt-[15px] mb-[11px] text-xs font-medium text-[#8a8f99]',
  result: {
    container:
      'mb-[9px] flex items-center gap-3 rounded-[13px] border border-[#f0f1f4] p-3',
    icon: 'flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-[10px] text-[13px] font-extrabold text-white',
    title: 'text-[13.5px] font-bold text-mf-off-black-600',
    subtitle: 'mt-0.5 text-xs text-[#8a8f99]',
  },
};
